import React from 'react';
import useReveal from '../hooks/useReveal';
import './About.css';

const MISSION = [
  'Make agricultural education practical and interactive.',
  'Bridge the gap between theory and field practice.',
  'Reduce the cost and risk of learning agriculture.',
  'Empower future farmers using immersive technologies.',
  'Help educational institutions modernize agricultural training.',
];

export default function About() {
  const ref = useReveal();
  const missionRef = useReveal();
  return (
    <section className="section about" id="about">
      <div className="container">
        <div className="reveal" ref={ref}>
          <p className="eyebrow">About Inivayal</p>
          <h2 className="section-heading">
            An agritech company building the future of agricultural education — not another
            farming company.
          </h2>
          <p className="section-sub" style={{ maxWidth: 720 }}>
            Inivayal Agritech Pvt. Ltd. is headquartered in Madurai, Tamil Nadu, developing
            interactive digital learning experiences so students, entrepreneurs and institutions
            can build real agricultural skill without the risk or cost of traditional hands-on
            training. Our first product simulates mushroom cultivation in realistic 3D — with
            multiple crops and domains planned next.
          </p>
        </div>

        <div className="about__grid">
          <div className="about__vision reveal" ref={useReveal()}>
            <h3>Our vision</h3>
            <p>
              To become the world's leading immersive agricultural learning platform — making
              practical farming education accessible, engaging, and technology-driven.
            </p>
          </div>

          <div className="about__mission reveal" ref={missionRef}>
            <h3>Our mission</h3>
            <ul>
              {MISSION.map((m) => (
                <li key={m}>
                  <span className="about__check">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M2 7.2L5.3 10.5L12 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  {m}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="about__audience reveal" ref={useReveal()}>
          <div>
            <h4>Who we build for</h4>
            <p>Agricultural colleges & universities, mushroom training institutes, and skill development centres.</p>
          </div>
          <div>
            <h4>Who else we serve</h4>
            <p>Individual entrepreneurs, beginner farmers, home growers, NGOs, government training programs, and incubation centres.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
